export enum UserRoles {
    Administrator = 'administrator',
    Editor = 'editor',
    Publisher = 'publisher'
}